export default "__VITE_ASSET__DM13twE___"